import LetterAvatar from "@/components/Avatar/LetterAvatar"
import DetailAvatar from "@/components/Avatar/DetailAvatar"
import StatusBadge from "@/components/ui/badge"
import CodeFormat from "@/components/ui/code"
import { Link } from "react-router-dom"
import { IconButton } from "@mui/material"
export const columns = [
  {
    header: "Code",
    cell: ({ row }) => <CodeFormat value={row.original.code} />,
  },
  {
    header: "Order Date",
    cell: ({ row }) => row.original.order_date,
  },
  {
    header: "Status",
    cell: ({ row }) => <StatusBadge name={row.original.status_parsed} />,
  },
  {
    header: "Total products",
    cell: ({ row }) => <StatusBadge name={row.original.order_items_count} />,
  },
  {
    header: "Total Amount",
    cell: ({ row }) => `Rs. ${row.original.total_amount}`,
  },
  {
    header: "Action",
    cell: ({ row }) => (
      <Link
        to={`/sales/${row.original.id}`}
        className="text-blue-500 hover:underline"
      >
        <IconButton aria-label="view" color="primary" sx={{ padding: "5px" }}>
          <i
            className="material-symbols-outlined"
            style={{
              fontSize: "16px",
            }}
          >
            visibility
          </i>
        </IconButton>
      </Link>
    ),
  },
]
